<template>
  <img src="@/assets/img/Icons/gallery/white.svg" />
</template>

<script>
export default {}
</script>

<style></style>
